(() => {
  if (customElements.get('ug-launch-sale')) return;
  class LaunchSale extends HTMLElement {
    connectedCallback() {
      if (this.timer) return;
      try { this.variants = JSON.parse(this.querySelector('[data-variants]').textContent); }
      catch (_) { this.hidden = true; return; }
      this.scope = this.closest('[id^="shopify-section-"]') || document;
      this.start = this.dataset.start ? Number(this.dataset.start) * 1000 : -Infinity;
      this.end = this.dataset.end ? Number(this.dataset.end) * 1000 : NaN;
      // Only an unpublished theme with an explicit preview URL can use sample dates.
      const preview = window.Shopify?.theme?.role === 'unpublished'
        ? new URLSearchParams(location.search).get('ug_sale_preview') : null;
      if (['active','before','ended','expire'].includes(preview)) {
        const now = Date.now();
        this.start = preview === 'before' ? now + 86400000 : now - 86400000;
        this.end = preview === 'ended' ? now - 1000 : now + (preview === 'expire' ? 15000 : 3 * 86400000);
        this.querySelector('[data-preview-note]').hidden = false;
      }
      if (Number.isFinite(this.end)) {
        // Display the exact end time entered on the product.
        const lastMinute = new Date(this.end);
        const deadline = new Intl.DateTimeFormat(this.dataset.locale || 'ja-JP', {
          timeZone:'Asia/Tokyo',year:'numeric',month:this.dataset.locale?.startsWith('en') ? 'short' : 'numeric',day:'numeric',
          hour:'2-digit',minute:'2-digit',hourCycle:'h23'
        }).format(lastMinute);
        this.querySelector('[data-deadline]').textContent = (this.dataset.deadlineTemplate || '__DATE__まで').replace('__DATE__',deadline);
      }
      this.savingRow = this.querySelector('.ug-launch-sale__saving');
      if (typeof ResizeObserver !== 'undefined' && this.savingRow) {
        this.rowObserver = new ResizeObserver(entries => {
          const width = entries[0].contentRect.width;
          if (width !== this.rowWidth) {
            this.rowWidth = width;
            this.fitSavingRow();
          }
        });
        this.rowObserver.observe(this.savingRow);
      }
      // Re-measure after existing web fonts finish; this does not request fonts.
      document.fonts?.ready.then(() => { if (this.isConnected) this.fitSavingRow(); });
      this.refresh = () => this.update();
      this.scope.addEventListener('change',this.refresh);
      window.addEventListener('popstate',this.refresh);
      window.addEventListener('pageshow',this.refresh);
      document.addEventListener('visibilitychange',this.refresh);
      // Existing theme silently updates its master variant selector; read that same selector.
      this.timer = setInterval(this.refresh,250);
      this.update();
    }
    fitSavingRow() {
      const row = this.savingRow;
      if (!row || !row.clientWidth) return;
      row.style.setProperty('--ug-sale-fit','1');
      const gap = parseFloat(getComputedStyle(row).columnGap) || 0;
      const required = Array.from(row.children).reduce((sum,item) => sum + item.getBoundingClientRect().width,0)
        + gap * Math.max(0,row.children.length - 1);
      if (required > row.clientWidth) {
        // Scale type and spacing together, leaving a pixel for rounding.
        row.style.setProperty('--ug-sale-fit',String((row.clientWidth - 1) / required));
      }
    }
    update() {
      const input = document.getElementById('id-' + this.dataset.section)
        || this.scope.querySelector('select[name="id"],form[action*="/cart/add"] [name="id"]');
      const id = input ? String(input.value || '') : this.dataset.initialVariant;
      const variant = this.variants.find(item => item.id === id);
      const now = Date.now();
      const active = Number.isFinite(this.end) && this.start < this.end
        && now >= this.start && now < this.end && variant && variant.compare > variant.price;
      this.hidden = !active;
      if (!active) return;
      if (this.currentVariant !== id) {
        this.currentVariant = id;
        this.querySelector('[data-saving]').textContent = variant.saving;
        this.fitSavingRow();
      }
      const remaining = Math.max(0,Math.ceil((this.end-now)/1000));
      if (remaining === this.remaining) return;
      this.remaining = remaining;
      const values = {day:Math.floor(remaining/86400),hour:Math.floor(remaining%86400/3600),minute:Math.floor(remaining%3600/60),second:remaining%60};
      Object.entries(values).forEach(([key,value]) => {
        this.querySelector('[data-unit="' + key + '"]').textContent = String(value).padStart(2,'0');
      });
    }
    disconnectedCallback() {
      clearInterval(this.timer);this.timer = null;
      this.rowObserver?.disconnect();
      this.scope?.removeEventListener('change',this.refresh);
      window.removeEventListener('popstate',this.refresh);
      window.removeEventListener('pageshow',this.refresh);
      document.removeEventListener('visibilitychange',this.refresh);
    }
  }
  customElements.define('ug-launch-sale',LaunchSale);
})();
